import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
import siteConfig from '../siteConfig.json'
const routes = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Download APK Latest v18.80 | Update 2026`,
			keywords: 'GB WhatsApp, GB WhatsApp APK download',
			description: `Download GB WhatsApp APK (2026 official latest version) with anti-ban protection. Get GB WhatsApp Pro for Android, iOS, and PC to enjoy secure chats, media sharing, and exclusive features.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/`,
				},
			],
		},
		component: () => import('@/views/home.vue'),
	},
	{
		path: '/download/',
		name: 'download',
		meta: {
			appname: 'GBWhatsApp',
			title: `GBWhatsApp v18.80 Download Page`,
			keywords: 'Download GB WhatsApp, Download GB WhatsApp APK',
			description: `Get the official GB WhatsApp APK 2026 safe download files for Android. Access the latest updated version APK. Fast, secure, and 100% malware-free download.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/download/`,
				},
			],
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/blog/',
		name: 'blogs',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Blogs for Users`,
			keywords: 'gbwhatsapp blogs',
			description: `Visit our site to join the hot discussion about GB WhatsApp App. Here we share detailed guide and blogs for you.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/blog/`,
				},
			],
		},
		component: () => import('@/views/blogs.vue'),
	},
	{
		path: '/resolving-gbwhatsapp-installation-issues/',
		name: 'blog-1',
		meta: {
			appname: 'GBWhatsApp',
			title: `Guide to Resolving GB WhatsApp Installation Issues`,
			keywords: 'Resolving GB WhatsApp Installation Issues',
			description: `GBWhatsApp not installing? Fix "App Not Installed", "Parse Error", Play Protect block, and version conflicts with this complete guide.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/resolving-gbwhatsapp-installation-issues/`,
				},
			],
		},
		component: () => import('@/views/blog-1.vue'),
	},
	{
		path: '/unread-messages-in-gbwhatsapp/',
		name: 'unread-messages-in-gbwhatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: `Methods to Unread Messages in GB WhatsApp`,
			keywords: 'unread messages in GB WhatsApp',
			description: `Explore effective methods to unread messages in GB WhatsApp, including viewing, marking, archiving, and privacy features for efficiency.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gbfreeapk.com/unread-messages-in-gbwhatsapp/`,
				},
			],
		},
		component: () => import('@/views/blog-2.vue'),
	},
	{
		path: '/should-i-stop-using-gbwhatsapp-in-2026/',
		name: 'blog-3',
		meta: {
			appname: 'GBWhatsApp',
			title: `Should I Stop Using GB WhatsApp in 2026?`,
			keywords: 'GB WhatsApp 2026, should stop using GB WhatsApp, ban risk, mod security',
			description: `Should you stop using GB WhatsApp in 2026? Understand ban signals, safety risks, and smarter ways to protect your chat data.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/should-i-stop-using-gbwhatsapp-in-2026/`,
				},
			],
		},
		component: () => import('@/views/blog-3.vue'),
	},
	{
		path: '/why-some-gbwhatsapp-apk-files-are-fake/',
		name: 'blog-4',
		meta: {
			appname: 'GBWhatsApp',
			title: `Why Some GB WhatsApp APK Files Are Fake`,
			keywords: 'fake GB WhatsApp APK, tampered APK, how to spot, mod safety',
			description: `Fake GB WhatsApp APK files are common. Learn why they happen and how to identify suspicious builds before you install.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/why-some-gbwhatsapp-apk-files-are-fake/`,
				},
			],
		},
		component: () => import('@/views/blog-4.vue'),
	},
	{
		path: '/what-happens-to-your-data-if-gb-whatsapp-gets-banned/',
		name: 'blog-5',
		meta: {
			appname: 'GBWhatsApp',
			title: `What Happens to Your Data If GB WhatsApp Gets Banned`,
			keywords: 'GB WhatsApp banned, what happens to your data, chat history, backups',
			description: `If GB WhatsApp gets banned, what happens to your messages and media? Here’s the typical outcome and what you can do before it happens.`,
			link: [
				{
					rel: 'canonical',
					href: `https://${siteConfig.domain}/what-happens-to-your-data-if-gb-whatsapp-gets-banned/`,
				},
			],
		},
		component: () => import('@/views/blog-5.vue'),
	},
	{
		path: '/how-to-read-messages-in-gbwhatsapp/',
		name: 'blog-6',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Read Deleted Messages in GB WhatsApp`,
			keywords: 'read deleted messages in GB WhatsApp, anti-delete messages, anti-revoke messages',
			description: `Someone deleted a message before you could read it? See how GB WhatsApp's Anti-Delete feature works and how to turn it on.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gbfreeapk.com/how-to-read-messages-in-gbwhatsapp/`,
				},
			],
		},
		component: () => import('@/views/blog-6.vue'),
	},
	{
		path: '/how-to-schedule-messages-in-gbwhatsapp/',
		name: 'blog-7',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Schedule Messages in GB WhatsApp`,
			keywords: 'schedule messages in GB WhatsApp, message scheduler, scheduled messages',
			description: `Need to send a WhatsApp message later? Learn how to schedule messages in GB WhatsApp and fix common scheduler problems.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gbfreeapk.com/how-to-schedule-messages-in-gbwhatsapp/`,
				},
			],
		},
		component: () => import('@/views/blog-7.vue'),
	},
	// ─── Features Hub ─────────────────────────────────────────────
	{
		path: '/features/',
		name: 'features',
		meta: {
			appname: 'GBWhatsApp',
			title: `Features Hub – GB WhatsApp Functional Overview Center`,
			keywords: 'Features Hub, GB WhatsApp Features, Feature Overview',
			description: `Explore the GB WhatsApp Features Hub for comprehensive guides on privacy control, media sharing, account management, and the theme system.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/features/` }],
		},
		component: () => import('@/views/features.vue'),
	},
	{
		path: '/features/custom-themes/',
		name: 'custom-themes',
		meta: {
			appname: 'GBWhatsApp',
			title: `Custom Themes – GB WhatsApp Theme System Guide`,
			keywords: 'Custom Themes, GB WhatsApp Themes, Theme Download, UI Customization',
			description: `Complete guide to GB WhatsApp's custom theme system: theme downloads, UI customization, font styles, and chat bubble personalization.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/features/custom-themes/` }],
		},
		component: () => import('@/views/custom-themes.vue'),
	},
	{
		path: '/features/privacy-control/',
		name: 'privacy-control',
		meta: {
			appname: 'GBWhatsApp',
			title: `Privacy Control – GB WhatsApp Privacy`,
			keywords: 'Privacy Control, GB WhatsApp Privacy, Hide Online, Anti-Revoke',
			description: `GB WhatsApp Privacy Control guide: Hide Online Status, Freeze Last Seen, and Anti-Revoke features for maximum privacy protection.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/features/privacy-control/` }],
		},
		component: () => import('@/views/privacy-control.vue'),
	},
	{
		path: '/features/media-sharing/',
		name: 'media-sharing',
		meta: {
			appname: 'GBWhatsApp',
			title: `Media Sharing – Enhanced Media Capabilities in GB WhatsApp`,
			keywords: 'Media Sharing, GB WhatsApp Media, Large File Sending, Image Quality',
			description: `GB WhatsApp media sharing guide: large file sending up to 1 GB, HD image quality, and extended video length beyond WhatsApp limits.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/features/media-sharing/` }],
		},
		component: () => import('@/views/media-sharing.vue'),
	},
	{
		path: '/features/account-management/',
		name: 'account-management',
		meta: {
			appname: 'GBWhatsApp',
			title: `Account Management – Multi-Account Support in GB WhatsApp`,
			keywords: 'Account Management, GB WhatsApp Multi-Account, Account Switching',
			description: `GB WhatsApp account management guide: multi-account support, instant switching, and notification separation for managing multiple identities.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/features/account-management/` }],
		},
		component: () => import('@/views/account-management.vue'),
	},
	// ─── Use Cases ──────────────────────────────────────────────
	{
		path: '/use-cases/',
		name: 'use-cases',
		meta: {
			appname: 'GBWhatsApp',
			title: `Use Cases – Find Your Perfect GB WhatsApp Scenario`,
			keywords: 'Use Cases, GB WhatsApp Use Cases, Scenario Guide',
			description: `Explore GB WhatsApp use cases for small business, content creators, gaming communities, and international users. Find your perfect scenario.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/use-cases/` }],
		},
		component: () => import('@/views/use-cases.vue'),
	},
	{
		path: '/use-cases/small-business/',
		name: 'small-business',
		meta: {
			appname: 'GBWhatsApp',
			title: `Small Business Use Case – GB WhatsApp for Entrepreneurs`,
			keywords: 'Small Business, GB WhatsApp Business, Business Communication',
			description: `GB WhatsApp for small business: media sharing for product catalogs, account management for work-life balance, and privacy features for professional boundaries.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/use-cases/small-business/` }],
		},
		component: () => import('@/views/small-business.vue'),
	},
	{
		path: '/use-cases/social-influencers/',
		name: 'social-influencers',
		meta: {
			appname: 'GBWhatsApp',
			title: `Social Influencers Use Case – GB WhatsApp for Content Creators`,
			keywords: 'Social Influencers, Content Creators, GB WhatsApp Influencers',
			description: `GB WhatsApp for content creators and social influencers: media sharing, custom themes for brand identity, and multi-account management for creator workflows.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/use-cases/social-influencers/` }],
		},
		component: () => import('@/views/social-influencers.vue'),
	},
	{
		path: '/use-cases/gaming-communities/',
		name: 'gaming-communities',
		meta: {
			appname: 'GBWhatsApp',
			title: `Gaming Communities Use Case – GB WhatsApp for Players and Guilds`,
			keywords: 'Gaming Communities, GB WhatsApp Gaming, Guild Communication',
			description: `GB WhatsApp for gaming communities: share gameplay clips at full quality, manage privacy in group chats, and separate gaming and personal accounts.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/use-cases/gaming-communities/` }],
		},
		component: () => import('@/views/gaming-communities.vue'),
	},
	{
		path: '/use-cases/international-users/',
		name: 'international-users',
		meta: {
			appname: 'GBWhatsApp',
			title: `International Users Use Case – GB WhatsApp for Cross-Border Communication`,
			keywords: 'International Users, GB WhatsApp International, Cross-Border Communication',
			description: `GB WhatsApp for international users: multi-language support, multi-number management, and privacy features for cross-border communication.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/use-cases/international-users/` }],
		},
		component: () => import('@/views/international-users.vue'),
	},
	// ─── Mods Hub ───────────────────────────────────────────────
	{
		path: '/mods/',
		name: 'mods',
		meta: {
			appname: 'GBWhatsApp',
			title: `WhatsApp Mods – Complete Guide to GBWhatsApp and Alternative Mods`,
			keywords: 'WhatsApp Mods, GB WhatsApp Alternatives, YO WhatsApp, FM WhatsApp',
			description: `Complete guide to WhatsApp mods: GB WhatsApp, YO WhatsApp, FM WhatsApp, Blue WhatsApp, Red WhatsApp, and WhatsApp Plus compared.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/mods/` }],
		},
		component: () => import('@/views/mods.vue'),
	},
	{
		path: '/mods/yowhatsapp/',
		name: 'yowhatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: `YO WhatsApp – The Ultimate WhatsApp Customization Experience`,
			keywords: 'YO WhatsApp, YOWhatsApp, WhatsApp Customization',
			description: `Complete guide to YO WhatsApp: theme system, icon customization, privacy features, media sharing, and how it compares to other WhatsApp mods.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/mods/yowhatsapp/` }],
		},
		component: () => import('@/views/yowhatsapp.vue'),
	},
	{
		path: '/mods/fmwhatsapp/',
		name: 'fmwhatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: `FM WhatsApp – The Media Sharing Specialist`,
			keywords: 'FM WhatsApp, FMWhatsApp, Media Sharing WhatsApp',
			description: `Complete guide to FM WhatsApp: extended video sharing, HD image quality, large file transfer up to 1 GB, and full feature overview.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/mods/fmwhatsapp/` }],
		},
		component: () => import('@/views/fmwhatsapp.vue'),
	},
	{
		path: '/mods/blue-whatsapp/',
		name: 'blue-whatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: `Blue WhatsApp – Accessible, Organized, and Feature-Rich`,
			keywords: 'Blue WhatsApp, BlueWhatsApp, Accessible WhatsApp Mod',
			description: `Complete guide to Blue WhatsApp: intuitive settings organization, privacy features, media sharing, and theme customization for all users.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/mods/blue-whatsapp/` }],
		},
		component: () => import('@/views/blue-whatsapp.vue'),
	},
	{
		path: '/mods/red-whatsapp/',
		name: 'red-whatsapp',
		meta: {
			appname: 'GBWhatsApp',
			title: `Red WhatsApp – Privacy-First Messaging for the Modern User`,
			keywords: 'Red WhatsApp, RedWhatsApp, Privacy WhatsApp Mod',
			description: `Complete guide to Red WhatsApp: advanced privacy features, Ghost Mode, granular privacy profiles, and comprehensive privacy protection guide.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/mods/red-whatsapp/` }],
		},
		component: () => import('@/views/red-whatsapp.vue'),
	},
	{
		path: '/mods/whatsapp-plus/',
		name: 'whatsapp-plus',
		meta: {
			appname: 'GBWhatsApp',
			title: `WhatsApp Plus – The Longest-Established WhatsApp Modification`,
			keywords: 'WhatsApp Plus, WA Plus, WhatsApp Mod',
			description: `Complete guide to WhatsApp Plus: the most established WhatsApp modification with proven stability, broad device compatibility, and reliable feature set.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/mods/whatsapp-plus/` }],
		},
		component: () => import('@/views/whatsapp-plus.vue'),
	},
	{
		path: '/about-us/',
		name: 'about-us',
		meta: {
			appname: 'GBWhatsApp',
			title: `About Us – GB Free Apk`,
			keywords: 'About Us, GB Free Apk, GB WhatsApp Information',
			description: `Learn about GB Free Apk – your trusted source for GB WhatsApp information. Not affiliated with Meta or WhatsApp.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/about-us/` }],
		},
		component: () => import('@/views/about-us.vue'),
	},
	{
		path: '/disclaimer/',
		name: 'disclaimer',
		meta: {
			appname: 'GBWhatsApp',
			title: `Disclaimer – GB Free Apk`,
			keywords: 'Disclaimer, Not affiliated with Meta, WhatsApp Terms of Service',
			description: `Official disclaimer for GB Free Apk. This website is not affiliated with WhatsApp or Meta Platforms, Inc.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/disclaimer/` }],
		},
		component: () => import('@/views/disclaimer.vue'),
	},
	{
		path: '/privacy-policy/',
		name: 'privacy-policy',
		meta: {
			appname: 'GBWhatsApp',
			title: `Privacy Policy – GB Free Apk`,
			keywords: 'Privacy Policy, Data Protection, User Privacy',
			description: `Privacy Policy for GB Free Apk. Learn how we collect, use, and protect your personal information.`,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/privacy-policy/` }],
		},
		component: () => import('@/views/privacy-policy.vue'),
	},
	{
		path: '/mods/gbwhatsapp/',
		redirect: '/',
	},
]
const siteMapRoutes = routes.map((e) => ({
	path: e.path,
}))
console.log(siteMapRoutes)
export { siteMapRoutes }
export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
